// extracted by mini-css-extract-plugin
export default {"button":"ShopBasket_button__arqAi","icon":"ShopBasket_icon__T7BAX","badge":"ShopBasket_badge__b2HG3","bump":"ShopBasket_bump__XBWab"};